import { STATUS_FIELD } from "modules/swiftboard/components/advance-filter";

// Advanced filter of the Template list. channel_fid / trigger_fid must also be in FILTER_FIELDS of the backend's
// reminder_library/template/controller.js; `generic` is handled there on its own.
export const templateFilterFields = [
  { key: "channel_fid", label: "Channel", type: "select", group: "Details", optionsKey: "channels", optionLabel: "name", optionValue: "id" },
  { key: "trigger_fid", label: "Trigger", type: "select", group: "Details", optionsKey: "triggers", optionLabel: "name", optionValue: "id" },
  { key: "generic", label: "Generic (no trigger)", type: "boolean", group: "Details" },
  { ...STATUS_FIELD, group: "Details" },
  { key: "created_date", label: "Created", type: "datetime", group: "Dates" },
];
